import React from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const { pathname } = useLocation();
  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <Link
            to={"/"}
            className={pathname === "/" ? "nav-link" : "nav-link collapsed"}
          >
            <i className="bi bi-grid" />
            <span>Dashboard</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to={"/driver"}
            className={
              (pathname === "/driver" || pathname.startsWith("/driver/")) &&
              !pathname.includes("/driver-archive")
                ? "nav-link"
                : "nav-link collapsed"
            }
          >
            <i class="bi bi-people" /> <span>Drivers</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={
              pathname.includes("/driver-archive")
                ? "nav-link"
                : "nav-link collapsed"
            }
            to={"/driver-archive"}
          >
            <i class="bi bi-archive"></i>
            <span>Driver Archive</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={
              pathname.includes("/agreement")
                ? "nav-link"
                : "nav-link collapsed"
            }
            to={"/agreement"}
          >
            <i class="bi bi-file-earmark" />
            <span>Driver Agreement</span>
          </Link>
        </li>
        {/* <li className="nav-item">
          <Link
            className={
              pathname.includes("/permissions")
                ? "nav-link"
                : "nav-link collapsed"
            }
            to={"/permissions"}
          >
            <i class="bi bi-file-earmark" />
            <span>Driver Permissions</span>
          </Link>
        </li> */}
        <li className="nav-item">
          <Link
            className={
              pathname.includes("/managereports")
                ? "nav-link"
                : "nav-link collapsed"
            }
            to={"/managereports"}
          >
            <i class="bi bi-flag" />
            <span>Reports</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname.includes("/users") ? "nav-link" : "nav-link collapsed"
            }
            to={"/users"}
          >
            <i class="bi bi-person-circle" />
            <span>Users</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname.includes("/banners") ? "nav-link" : "nav-link collapsed"
            }
            to={"/banners"}
          >
            <i className="bi bi-image" />
            <span>Banners</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={
              pathname.includes("/settings") ? "nav-link" : "nav-link collapsed"
            }
            to={"/settings"}
          >
            <i class="bi bi-gear"></i>
            <span>Settings</span>
          </Link>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
